import { MatCardModule } from '@angular/material/card';
import { NgModule, ErrorHandler } from '@angular/core';
import { SearchPipe } from './pipes/search.pipe';
import {DateConvertPipe} from './pipes/dateConvert.pipe';
import { FormsModule } from '@angular/forms';
import { ThemeLibModule } from 'bh-theme';
import { SearchComponent } from '../components/ple-search/ple-search.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTooltipModule} from '@angular/material/tooltip';
import { EventMqttService } from './services/event.mqtt.service';
import { AdvantageLogDisplay } from './pipes/advantagelogDisplay.pipe';
import {PublishRateDisplay} from './pipes/publishRateValue.pipe';
import { KeysPipe } from './pipes/keysPipe';
import {MatIconModule}  from '@angular/material/icon';


@NgModule({
  declarations: [
    SearchPipe,
    DateConvertPipe,
    SearchComponent,
    AdvantageLogDisplay,
    PublishRateDisplay,
    KeysPipe
  ],
  imports: [
    FormsModule,
    ThemeLibModule,
    MatCardModule,
    MatIconModule
  ],
  exports: [
    FormsModule,
    SearchPipe,
    ThemeLibModule,
    MatCardModule,
    DateConvertPipe,
    SearchComponent,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatTooltipModule,
    AdvantageLogDisplay,
    PublishRateDisplay,
    KeysPipe
  ],
  providers: [
    {
      provide: ErrorHandler
    },
    EventMqttService
  ]
})
export class SharedModule { }